import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-32 overflow-hidden" data-id="element-111" data-mp="ejwfyzd2ht1i">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-112" data-mp="eilej673gxdk">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-113" data-mp="9ll8gva8vumg">
          <div className="max-w-2xl" data-id="element-114" data-mp="4mi2n8mfxkdf">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-title font-bold text-stone-900 leading-tight mb-8" data-id="element-115" data-mp="4njqyesgw3d3">
              Hello, I'm <br className="hidden sm:block" data-id="element-116" data-mp="xae9351taqne" />
              <span className="text-brand-800 italic" data-id="element-117" data-mp="xbfi73z9p32h">Dr. Scott Conkright</span>
            </h1>

            <div className="space-y-6 text-lg md:text-xl text-stone-600 leading-relaxed mb-10" data-id="element-118" data-mp="sa9slf0wlvx6">
              <p data-id="element-119" data-mp="nb6lzq59zhn3">
                I'm a licensed psychologist in Atlanta and Washington D.C. My
                work is collaborative and practical — whether we work together
                for a few sessions or a few years, the goal is always the same:
                a healthier relationship with yourself and with others.
              </p>
              <p data-id="element-120" data-mp="3j6obhix6kkpk">
                I'm also the founder of Meaningful Happiness and The
                Relationship Workshops.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center gap-4" data-id="element-121" data-mp="399jo5frlmj76">
              <a href="#assessment" className="inline-flex justify-center items-center px-7 py-4 bg-brand-800 text-white rounded-full font-semibold hover:bg-brand-900 transition-all hover:shadow-lg hover:-translate-y-0.5" data-id="element-122" data-mp="3e8msexzr8le3">
                Discover Your Relationship Animal
                <ArrowRight className="ml-2 h-5 w-5" data-id="element-123" data-mp="2ql68aimn7wy8" />
              </a>
              <a href="/therapy/individual" className="inline-flex justify-center items-center px-7 py-4 bg-white text-brand-800 border border-brand-200 rounded-full font-semibold hover:bg-brand-50 transition-colors" data-id="element-124" data-mp="2vi53l4i1m9y0">
                Explore Therapy
              </a>
            </div>
            <p className="mt-5 text-sm text-stone-500" data-id="element-125" data-mp="s3mcu1g2bwxu">
              Understand your relationship patterns — or work with me to change them.
            </p>
          </div>

          {/* Primary portrait — swap src with Dr. Conkright's photo */}
          <div className="relative" data-id="element-126" data-mp="ddf3cb819o9a">
            <div className="relative aspect-[4/5] rounded-3xl overflow-hidden bg-brand-100 shadow-xl" data-id="element-127" data-mp="degfkj0scgsl">
              <img src="https://cdn.magicpatterns.com/uploads/a4CnRX4eFBMXEsAq1nkY5W/DrScott.jpg" alt="Dr. Scott Conkright" className="w-full h-full object-cover" data-id="element-128" data-mp="1azkvlrn8ois7" />
            </div>
            <div className="absolute -bottom-6 -left-6 w-28 h-28 bg-brand-200 rounded-2xl -z-10" data-id="element-129" data-mp="x14o3yhjyo90"></div>
          </div>
        </div>
      </div>

      {/* Decorative background element */}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[800px] h-[800px] bg-brand-100 rounded-full blur-3xl opacity-50 -z-10" data-id="element-130" data-mp="3lqui5yd6ip9t"></div>
    </section>;
}